import { Component } from '@angular/core';

@Component({
  templateUrl: './layout.html'  
})
export class LayoutComponent { 

    constructor() { }
}


// WEBPACK FOOTER //
// C:/Users/jjarvis/projects/pm-controls/test/views/home/layout/layout-component.ts